// Config for Make an offer feature
export const offersFeature = false;
